module.exports = __webpack_public_path__ + "img/sentimentlogo.b17a85f7.png";